import React from "react";
import Page from "@jumbo/shared/Page";
import DataVerification from "./DataVerification";

import TenantAdminRoute from "../../routes/TenantAdminRoute";

const DV_routes = [
    {
        path: "/data-verification",
        element: <TenantAdminRoute element ={<Page component={DataVerification}/>} />
    }
];

export default DV_routes;
